{/* Auto-generated icon - do not edit */}
import React from 'react'

interface BalloonIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const BalloonIcon = React.forwardRef<SVGSVGElement, BalloonIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 96 159"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M33.9541 117.276C14.6781 104.228 4.37829 86.3624 1.22393 64.0927C-0.0231132 55.3096 -0.0125902 46.4799 2.70662 38.0728C9.11247 18.2685 22.6539 5.87941 43.2124 1.9696C53.7991 -0.0433869 63.4894 3.33152 72.0954 9.51027C84.1851 18.1903 92.0402 29.7458 94.6078 44.5586C96.4954 55.3694 94.9438 66.4996 90.1722 76.3828C85.3547 86.6702 78.5938 95.6023 70.5385 103.527C65.5922 108.392 60.2995 112.907 55.1145 117.624C55.9841 118.131 57.2148 118.794 58.387 119.542C60.2714 120.679 61.8484 122.261 62.9801 124.148C64.1118 126.037 64.7636 128.173 64.8787 130.371C65.0573 132.609 65.2825 134.851 65.3173 137.093C65.3921 141.904 67.6894 145.397 71.5408 148.031C74.8697 150.308 78.2183 152.56 81.5171 154.876C82.056 155.365 82.5311 155.92 82.9302 156.529C82.2627 157.046 81.6333 157.931 80.9185 158.007C79.2678 158.182 77.4622 158.326 75.9212 157.842C70.7151 156.205 66.0151 153.588 62.3579 149.429C59.0585 145.676 58.0424 141.171 58.2459 136.274C58.4069 133.928 58.3629 131.572 58.1146 129.233C57.9039 127.67 56.9989 126.202 56.0958 123.917C55.4585 125.365 55.2064 126.01 54.8959 126.627C54.5626 127.284 54.055 127.836 53.4286 128.224C52.8022 128.612 52.0812 128.82 51.3445 128.825C45.0909 129.277 38.8315 129.643 32.5825 130.148C30.5131 130.315 28.7625 130.029 27.6644 128.104C26.6603 126.344 26.9982 124.545 28.7802 122.591C30.421 120.793 32.1781 119.092 33.9541 117.276ZM87.7372 52.0639C87.6841 50.8661 87.6388 49.2948 87.5338 47.7275C87.4589 47.0598 87.3493 46.3964 87.2056 45.7401C85.0049 33.0118 78.3614 23.0506 67.9316 15.676C61.8866 11.4019 55.2142 8.701 47.5042 9.14206C31.0013 10.0859 14.6217 24.1394 10.2505 40.6594C8.24958 48.5143 7.83911 56.6898 9.04296 64.7057C10.9759 78.7613 16.722 91.0841 25.6272 102.038C28.7074 105.828 32.4886 108.777 36.3722 111.664C39.2738 113.821 42.2135 113.489 45.2628 112.313C45.9723 111.981 46.6614 111.606 47.3264 111.191C53.6613 107.831 58.7467 102.896 63.8346 97.9874C71.0269 91.1963 77.115 83.3248 81.8801 74.6566C85.6133 67.7033 87.6224 59.9551 87.7372 52.0639Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="95.8253" height="157.521" fill={color} transform="translate(0.0150146 0.861328)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

BalloonIcon.displayName = 'BalloonIcon'
